import React from 'react';
import { ErrorBoundary } from 'components/Errors';
import Login from './Login';

const AsyncLogin = () => (
  <ErrorBoundary>
    <Login />
  </ErrorBoundary>
);

export default AsyncLogin;
